/* eslint-disable functional/no-let */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable max-lines-per-function */
/* eslint-disable functional/immutable-data */
import { useOrderValueData } from "../../app/hooks/useOrderValueData";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { buildFurthestContinueIndex } from "../miscellaneous/buildFurthestContinueIndex";
import { cartFlowSequence } from "../miscellaneous/cartFlowSequence";
import { groupErrorToPage } from "../miscellaneous/groupErrorToPage";
import { isNextPageSampleQuestions } from "../miscellaneous/isNextPageSampleQuestions";
import { useLocation } from "./useLocation";

type UseNextPageIndexInput = {
  readonly peekPastErrorGroup?: true;
  readonly peekWithinErrorGroup?: true;
  readonly peekWithinPath?: true;
};

export function useNextPageIndex(input?: UseNextPageIndexInput) {
  const order = useOrderValueData();
  const { pathname } = useLocation();

  if (order.tag === "initializing") {
    return "initializing";
  } else {
    const errorRequired = order.data.errors?.find((item) => {
      return item.errorCode === "RequiredApiNotAvailable";
    });

    const sorted = [...(order.data.errors ?? [])].sort((errorA, errorB) => {
      const aIndex = buildFurthestContinueIndex(errorA)();
      const bIndex = buildFurthestContinueIndex(errorB)();

      return aIndex < bIndex ? -1 : 1;
    });

    const currentPage = cartFlowSequence.find(
      (item, index) =>
        `${getPartnerPathnameClient(true)}${item.path}` === pathname &&
        (input?.peekWithinPath
          ? `${getPartnerPathnameClient(true)}${cartFlowSequence[index + 1]?.path
          }` !== pathname
          : true)
    );
    const nextError = sorted.find((first) => {
      return input?.peekPastErrorGroup
        ? groupErrorToPage(first.errorGroup) !== currentPage?.errorPage
        : first;
    });

    let nextIndex = nextError
      ? buildFurthestContinueIndex(nextError, {
        peekWithinErrorGroup: input?.peekWithinErrorGroup,
      })()
      : cartFlowSequence.length - 1;

    // The code for handle refresh Cart Purchase page (pageIndex = 0) after add new item to cart and
    // not go to Shipping Address page.
    // With this status, the next page navigate to is Shipping Address page.
    // Ticket bug: https://dev.azure.com/digikey/Portfolio/_workitems/edit/478282
    if (
      nextIndex === 0 &&
      order.data.errors?.find(
        (error) => error.errorGroup === "CustomerAgreements"
      )
    ) {
      nextIndex = cartFlowSequence.findIndex(
        (item) => item.errorPage === "ShippingAddress"
      );
    }

    //When non-English characters are contained in the customer reference, it will show Continue to Shipping Address button text.
    if (
      order.data.errors?.find(
        (error) => error.errorGroup === "Cart" && error.errorCode === "CustomerReferenceNonEnglishCharNotAllowed"
      ) && order.data.orderLines?.some((line) => !!line.isSample)
    ) {
      nextIndex = cartFlowSequence.findIndex(
        (item) => item.errorPage === "SampleQuestions"
      );
    }
    else if (
      order.data.errors?.find(
        (error) => error.errorGroup === "Cart" && error.errorCode === "CustomerReferenceNonEnglishCharNotAllowed"
      ) && order.data.orderLines?.some((line) => !line.isSample)
    ) {
      nextIndex = cartFlowSequence.findIndex(
        (item) => item.errorPage === "ShippingAddress"
      );
    }

    // Redirect to a Cart page when Required Api not available
    if (!!errorRequired) {
      nextIndex = cartFlowSequence.findIndex(
        (item) => item.errorPage === "Cart"
      );
    }

    // Check if user is stop at sample userregistration, then the next page is must a Sample Question page.
    // Follow ticket: https://dev.azure.com/digikey/Portfolio/_workitems/edit/606706
    nextIndex = isNextPageSampleQuestions(nextIndex, pathname);

    // Check if user trying to change url, with out checking sample aggrement check box.
    // Follow ticket: https://dev.azure.com/digikey/Portfolio/_workitems/edit/618674
    const isExistsSampleParts =
      order.tag === "ready" &&
      order.data.orderLines?.some((line) => !!line.isSample);
    const hasSamplesAgreed =
      order.tag === "ready" &&
      order.data.customerInformation?.hasSamplesAgreement;

    if (
      isExistsSampleParts &&
      hasSamplesAgreed === false &&
      !pathname.includes("/samples")
    ) {
      nextIndex = cartFlowSequence.findIndex(
        (item) => item.errorPage === "Cart"
      );
    } else if (
      isExistsSampleParts &&
      hasSamplesAgreed === false &&
      pathname.includes("/samples")
    ) {
      nextIndex = cartFlowSequence.findIndex(
        (item) => item.errorPage === "Cart" && item.path === "/samples"
      );
    }

    // Save cookie for go to next page to hotfix bug can't navigate.
    document.cookie = `mkhcNextIndex=${nextIndex}; path=/`;

    return nextIndex;
  }
}
